//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FlipCountdown from 'vue2-flip-countdown'
export default {
  name: 'Countdown',
  components: { FlipCountdown },
  props: {
    endDate: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {}
  },
  methods: {
    timeElapsed() {
      this.$store.commit('setMaintenanceEndDate', undefined)
    },
  },
}
